import React, {FC, memo} from 'react';

import H1 from '../../../Headings/H1';

// Import Breadcrumbs
import Breadcrumbs from '../../../Breadcrumbs';
import breadcrumbsConfig from '../../../../config/breadcrumbs';
import {formatDateObj} from '../../../../utils/date'

// import messages from './messages';
import {Tag} from '../../../Tag';
import { NewsItem } from '../../../../models/newsItem';

interface INewsPrimaryDetails {
    item: NewsItem;
}

const Title: FC<INewsPrimaryDetails> = ({item}) => {

    return (
        <>
            <Breadcrumbs items={[...breadcrumbsConfig.news_details,...[{label:item.title}]]} />
            <H1>{item.title}</H1>
            <Tag theme="light_gray">
                <svg><use xlinkHref={`#calendar-purple`} /></svg> Objavljeno: {formatDateObj(item.published_at)}
            </Tag>
            <Tag theme="light_gray">
                <svg><use xlinkHref={`#category-purple`} /> </svg>{item.category_name}
            </Tag>
            <Tag theme="light_gray">
                <svg><use xlinkHref={`#published-purple`} /></svg> Objavljuje: {item.user.company_name}
            </Tag>
        </>
    )
}

export default memo(Title);